import TimeSheetModel from '../models/TimeSheetModel';

export default class TimeSheetCollection extends Backbone.Collection {
  constructor(options) {
    super(options);
    this.model = TimeSheetModel;
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;

    switch (actionType) {
      case ActionTypes.GET_TIMESHEETS:
        Utils.setMakeshiftTokenHeader();
        const tsURL = appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.TIMESHEETS;
        TimeSheetStore.fetch({
          url: tsURL,
          type: 'GET',
          success: TimeSheetStore.onTimeSheetHandler,
          error: TimeSheetStore.onTimeSheetError,
        });
        break;
      case ActionTypes.APPROVE_PUNCHES:
        Utils.setMakeshiftTokenHeader();
        const punchURL = appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.TIMESHEET_APPROVAL;
        TimeSheetStore.fetch({
          url: punchURL,
          type: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify(payload.postData),
          success: TimeSheetStore.onPunchesApprovedHandler,
          error: TimeSheetStore.onPunchesApprovalError,
        });
        break;
    }
  }
}
